function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#booking_svg__clip0)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#booking_svg__clip1)",
  fill: "current"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.7 10.19L7 16.03v7.62l9.7-5.84v-7.62zM16.7 0L7 5.84v7.62l9.7-5.84V0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "booking_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "booking_svg__clip1"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(7)",
  d: "M0 0h9.7v23.65H0z"
})));

function SvgBooking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgBooking;